export const formatLinkLng = (url: string, language: string): string => {
    return url.replace('{{lng}}', language);
};
